// extracted by mini-css-extract-plugin
var _1 = "WalkthroughScreen_WalkthroughScreen__sTsEI";
var _2 = "WalkthroughScreen_content__KnOwJ";
var _3 = "WalkthroughScreen_contentContainer__R-uOP";
var _4 = "WalkthroughScreen_image__6ZBmf";
var _5 = "WalkthroughScreen_imageContainer__fMTnC";
var _6 = "WalkthroughScreen_skipButton__L9XfS";
var _7 = "WalkthroughScreen_skipButtonContainer__+OvPl";
export { _1 as "WalkthroughScreen", _2 as "content", _3 as "contentContainer", _4 as "image", _5 as "imageContainer", _6 as "skipButton", _7 as "skipButtonContainer" }
